export { version } from './src/package.js'
import { translate } from './src/translate.js'

if (typeof jQuery != 'undefined') {
  jQuery.extend(jQuery.fn, {
    translate: translate
  })
}
